import { Component, createEffect, on, onCleanup, onMount } from 'solid-js'

import { produce } from 'solid-js/store'
import { loadingState, self, setLoadingState } from 'store/user'
import './style/loadingpage.scss'

const TEXTS = [
    '',
    'سلام!',
    'خوش',
    'اومدی!',
    'در حال',
    'اتصال',
    'به گوجه',
    'هستی.',
    'معمولا',
    'انقدر',
    'طول',
    'نمی‌کشه',
    'اینترنتت',
    'وصله؟',
]

const LoadingPage: Component = () => {
    let mainRef: HTMLElement
    let imgRef: HTMLImageElement

    let interval: ReturnType<typeof setInterval>

    onMount(() => {
        interval = setInterval(() => {
            setLoadingState(
                produce(s => {
                    s.active += 1 % TEXTS.length
                })
            )
        }, 1000)

        onCleanup(() => clearInterval(interval))
    })

    createEffect(
        on(
            () => self.loading,
            loading => {
                if (loading || !imgRef) return

                let count =
                    loadingState.itterated % 2 == 0
                        ? loadingState.itterated
                        : loadingState.itterated + 1

                imgRef.style.animationIterationCount = String(count + 2)
            }
        )
    )

    return (
        <div
            ref={e => (mainRef = e)}
            class='loading-page'
            classList={{
                animate: loadingState.started,
                none: loadingState.ended,
            }}
        >
            <div
                class='svg-wrapper'
                ontransitionend={() => {
                    setLoadingState({ ended: true })
                }}
            >
                <img
                    fetchpriority='high'
                    ref={e => (imgRef = e)}
                    src='/public/svgs/mascot/happy.svg'
                    onAnimationIteration={e => {
                        if (!self.loading) return
                        setLoadingState(
                            produce(s => {
                                s.itterated = Math.ceil(e.elapsedTime)
                            })
                        )
                    }}
                    onanimationend={() => {
                        setLoadingState({ started: true })

                        setTimeout(() => {
                            mainRef.remove()
                        }, 1e3)
                    }}
                />
            </div>
            <div class='text title' classList={{ hide: !self.loading }}>
                <span>{TEXTS[loadingState.active]}</span>
            </div>
        </div>
    )
}

export default LoadingPage
